import * as EventListeners from '../constants/EventListeners';
export const isValidEventType = event => {
  return Boolean(EventListeners[event]);
};